import { ZEM_HISTORY_TYPE } from '../../../../../libs/service/apis/src/zem-history';
import { Donation } from '../../types/DonationTypes';

export type HistoryDetail =
  | { text: string; translationKey?: never; defaultValue?: never }
  | { text?: never; translationKey: string; defaultValue: string };

export const getDonationHistoryTypeTranslationKey = (item: Donation) => {
  switch (item.historyType) {
    case ZEM_HISTORY_TYPE.DONATION_RECEIVED:
      return item.donateType === ''
        ? 'manage:zemHistoryTypeGiftReceived'
        : 'manage:donate_history_received';
    case ZEM_HISTORY_TYPE.CHARGE:
      return 'manage:donate_charge_zem';
    case ZEM_HISTORY_TYPE.AVATAR_SHAPE_PURCHASE:
      return 'manage:zem_history_type_avatar_shape_purchase';
    case ZEM_HISTORY_TYPE.EQUIPMENT_PURCHASE:
      return 'manage:zem_history_type_equipment_purchase';
    default:
      return item.donateType === ''
        ? 'manage:zemHistoryTypeGiftSent'
        : 'manage:donate_history_sent';
  }
};

export const getDonationHistoryDetail = (item: Donation): HistoryDetail => {
  if (item.historyType === ZEM_HISTORY_TYPE.CHARGE) return { text: '-' };
  if (item.historyType === ZEM_HISTORY_TYPE.DONATION_RECEIVED) {
    return { text: item.playerName || '-' };
  }

  if (!item.historyType || item.historyType === ZEM_HISTORY_TYPE.DONATION) {
    return { text: item.targetPlayerName || '-' };
  }

  const sku = item.itemSku?.trim();
  if (!sku || !item.itemType) return { text: '-' };

  return {
    translationKey: `wearables:${item.itemType}.${sku}.name`,
    defaultValue: sku,
  };
};

export const getDonationHistoryRowKey = (
  item: Donation,
  index: number,
): string =>
  item.historyType && item.historyId != null
    ? `${item.historyType}-${item.historyId}`
    : `${item.createdAt}-${item.amount}-${index}`;

export const getDonationHistoryAmountSign = (item: Donation): '+' | '−' =>
  item.historyType === ZEM_HISTORY_TYPE.CHARGE ||
  item.historyType === ZEM_HISTORY_TYPE.DONATION_RECEIVED
    ? '+'
    : '−';
